export const truncate = {
  methods: {
    truncate (string, limit) {
      return string.substring(0, limit) + '…'
    }
  }
}
